// PWA install UX for mobile: show an "Install app" button when the browser
// exposes `beforeinstallprompt`, and fall back to manual instructions.

let deferredPrompt = null;
let installHandlerBound = false;

const isLikelyAndroid = () =>
  typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent || "");

const setStatus = (message) => {
  const el = document.getElementById("pwa-install-status");
  if (!el) return;
  if (!message) {
    el.style.display = "none";
    el.textContent = "";
    return;
  }
  el.style.display = "inline-block";
  el.textContent = message;
};

const bindInstallHandler = () => {
  if (installHandlerBound) return;
  installHandlerBound = true;

  const btn = document.getElementById("pwa-install-btn");
  if (!btn) return;

  btn.addEventListener("click", async () => {
    setStatus("");
    const fallback = document.getElementById("pwa-install-fallback");

    if (!deferredPrompt) {
      if (fallback) fallback.hidden = false;
      setStatus(isLikelyAndroid() ? "If Install doesn’t open, use ⋮ → Add to Home screen." : "Use your browser menu to add to Home Screen.");
      return;
    }

    try {
      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;
      if (choice && choice.outcome === "accepted") {
        btn.hidden = true;
        setStatus("Installing…");
      } else {
        // User dismissed; keep button visible.
        if (fallback) fallback.hidden = false;
        setStatus(isLikelyAndroid() ? "Tip: you can also use ⋮ → Add to Home screen." : "");
      }
    } catch (_error) {
      // Some browsers (notably Brave) may ignore/throw even when installable.
      if (fallback) fallback.hidden = false;
      setStatus(isLikelyAndroid() ? "Install prompt unavailable in this browser. Use ⋮ → Add to Home screen." : "Install prompt unavailable. Use your browser menu.");
    } finally {
      deferredPrompt = null;
    }
  });
};

const showInstallUI = () => {
  const btn = document.getElementById("pwa-install-btn");
  const fallback = document.getElementById("pwa-install-fallback");
  if (!btn) return;

  btn.hidden = false;
  if (fallback) fallback.hidden = true;
  setStatus("");
};

document.addEventListener("turbo:load", () => {
  bindInstallHandler();
});

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  deferredPrompt = event;
  showInstallUI();
});

window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  const btn = document.getElementById("pwa-install-btn");
  if (btn) btn.hidden = true;
  setStatus("");
});

// Best-effort SW registration for installability/offline.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => {
        // Non-fatal; install prompt may still appear depending on browser.
      });
  });
}

